import { render } from "./3-nights.vue?vue&type=template&id=165dc3fd&scoped=true"
import script from "./3-nights.vue?vue&type=script&lang=js"
export * from "./3-nights.vue?vue&type=script&lang=js"

import "./3-nights.vue?vue&type=style&index=0&id=165dc3fd&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165dc3fd"]])

export default __exports__